import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { Device, from } from '@helpers/media';
import styled from 'styled-components';
import ProductDropdownStyles from '../ProductDropdown/ProductDropdown.styles';
import TradeDropdownStyles from '../TradeDropdown/TradeDropdown.styles';

const Container = styled.div`
  --dropdownOffset: 8px;
  --maxWidth: calc(100% - ${fluid(24, 48, Device.DesktopSmall)});
  --verticalContainerPadding: 32px;

  &[data-narrow-width='true'] {
    @media ${from(Device.DesktopLarge)} {
      --maxWidth: 1576px;
    }
  }

  position: absolute;
  z-index: 1;
  top: calc(100% + var(--dropdownOffset));
  left: 0;
  right: 0;
  width: 100%;
  max-width: var(--maxWidth);
  background-color: ${brand.white};
  border-radius: 12px;
  margin: 0 auto;
  opacity: 0;
  pointer-events: none;

  &[aria-current='true'] {
    opacity: 1;
    pointer-events: all;
  }

  &::before {
    content: '';
    position: absolute;
    top: calc(-1 * var(--dropdownOffset));
    left: 0;
    width: 100%;
    height: var(--dropdownOffset);
  }
`;

const Inner = styled.div`
  padding: var(--verticalContainerPadding) ${fluid(16, 40, Device.DesktopSmall, Device.ActualDesktop)};

  // Product dropdown variant is 'A'
  [data-narrow-width='true'] & {
    // Prevents the scrollbar from appearing on the first column
    ${ProductDropdownStyles.Container} > ${ProductDropdownStyles.Column}:first-child {
      overflow-y: initial;
      max-height: initial;
    }
  }

  // Product dropdown variant is 'B'
  [data-narrow-width='false'] & {
    overflow: hidden;
    border-top-right-radius: 12px;
    border-bottom-right-radius: 12px;

    // Prevents the scrollbar from appearing on direct columns of the container
    ${ProductDropdownStyles.Container} > ${ProductDropdownStyles.Column},
    ${TradeDropdownStyles.Container} > ${TradeDropdownStyles.Column} {
      overflow-y: initial;
      max-height: initial;
    }

    ${ProductDropdownStyles.Container} > ${ProductDropdownStyles.Column}:first-child, 
    ${TradeDropdownStyles.Container} > ${TradeDropdownStyles.Column}:first-child {
      position: relative;
      padding-right: ${fluid(16, 40, Device.DesktopSmall, Device.ActualDesktop)};
      overflow-y: initial;
      max-height: initial;

      &::after {
        content: '';
        position: absolute;
        top: calc(var(--verticalContainerPadding) * -1);
        right: 0;
        width: 2px;
        height: calc(100% + (var(--verticalContainerPadding) * 2));
        background-color: ${brand.grey[80]};
      }
    }

    ${ProductDropdownStyles.Container} > ${ProductDropdownStyles.Column}:nth-child(2),
    ${TradeDropdownStyles.Container} > ${TradeDropdownStyles.Column}:nth-child(2) {
      position: relative;
      background-color: ${brand.grey[97]};
      padding: var(--verticalContainerPadding) 0 var(--verticalContainerPadding)
        ${fluid(16, 40, Device.DesktopSmall, Device.ActualDesktop)};
      margin: calc(var(--verticalContainerPadding) * -1) 0 calc(var(--verticalContainerPadding) * -1) 0;

      // accounts for the padding on the right side to fill the gap
      &::after {
        content: '';
        position: absolute;
        top: 0;
        right: calc(${fluid(16, 40, Device.DesktopSmall, Device.ActualDesktop)} * -1);
        width: ${fluid(16, 40, Device.DesktopSmall, Device.ActualDesktop)};
        height: 100%;
        background-color: ${brand.grey[97]};
      }
    }
  }
`;

const DesktopNavigationDropdownStyles = {
  Container,
  Inner,
};

export default DesktopNavigationDropdownStyles;
